"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * reef REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYZCoordArrayToJSON = exports.XYZCoordArrayFromJSONTyped = exports.XYZCoordArrayFromJSON = void 0;
const _1 = require("./");
function XYZCoordArrayFromJSON(json) {
    return XYZCoordArrayFromJSONTyped(json, false);
}
exports.XYZCoordArrayFromJSON = XYZCoordArrayFromJSON;
function XYZCoordArrayFromJSONTyped(json, ignoreDiscriminator) {
    // This is a manual change to the template in an attempt to fix:
    // https://github.com/OpenAPITools/openapi-generator/issues/5264
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return json.map(value => _1.XYZCoordFromJSON(value));
}
exports.XYZCoordArrayFromJSONTyped = XYZCoordArrayFromJSONTyped;
function XYZCoordArrayToJSON(value) {
    return value;
}
exports.XYZCoordArrayToJSON = XYZCoordArrayToJSON;
